import clsx from "clsx";
import React from "react";

import s from "./Title.less";

interface ITitleProps {
  size?: "lg" | "md" | "sm" | "xl";
  title?: string;
  className?: string;
}

export const Title = ({ title, size = "lg", className }: ITitleProps) => {
  return (
    <div className={clsx(s.title, s[`titleSize-${size}`], className)}>
      {title}
    </div>
  );
};
